import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  TransitionChild,
} from "@headlessui/react";

import { useNavigationStore } from "~/stores";
import { icons } from "~/ui";
import { NavigationDrawer } from "./NavigationDrawer";

export const MobileNavigation = () => {
  const { sidebarOpen, closeSidebar } = useNavigationStore();

  return (
    <Dialog
      open={sidebarOpen}
      onClose={closeSidebar}
      className="relative z-50 lg:hidden"
    >
      <DialogBackdrop
        transition
        className="data-closed:opacity-0 fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear"
      />

      <div className="fixed inset-0 flex">
        <DialogPanel
          transition
          className="data-closed:-translate-x-full relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out"
        >
          <TransitionChild>
            <div className="data-closed:opacity-0 absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out">
              <button
                type="button"
                onClick={closeSidebar}
                className="-m-2.5 p-2.5"
              >
                <span className="sr-only">Close sidebar</span>
                <icons.outline.XMarkIcon
                  aria-hidden="true"
                  className="size-6 text-white"
                />
              </button>
            </div>
          </TransitionChild>

          <NavigationDrawer />
        </DialogPanel>
      </div>
    </Dialog>
  );
};
